import { useLocation } from 'react-router';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import Uuid from '../../../model/Uuid';
import useTezaurusDetail from '../../../hooks/useTezaurusDetail';
import usePouzitiePredpisList from '../../../hooks/usePouzitiePredpisList';

// eslint-disable-next-line prefer-regex-literals
const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-f]{12}$/i;

const mapSearchText = (searchText: string): string => {
  if (searchText && searchText.trim().length > 0) {
    return searchText;
  }
  return '';
};

const predpisListToIdArray = (predpisList: string): Array<Uuid> => {
  if (!predpisList) {
    return null;
  }

  return predpisList.split(',')
    .map(item => item.trim())
    .filter(uuid => uuid && uuid.match(uuidRegex));
};

const getTezaurusUuid = (uuid: string): Uuid => {
  if (uuid && uuid.match(uuidRegex)) {
    return uuid;
  }
  return null;
};

interface ReturnType {
  initialFilter: PublikovanyTerminFilter;
  initialFilterLoading: boolean;
  initialFilterFinished: boolean;
}

export default (): ReturnType => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  const tezaurusUuid = getTezaurusUuid(search.get('tezaurus'));
  const predpisList = predpisListToIdArray(search.get('predpisList'));

  const {
    tezaurus,
    tezaurusStatus,
  } = useTezaurusDetail(tezaurusUuid, tezaurusUuid !== null);

  const {
    pouzitiePredpisList,
    pouzitiePredpisListStatus,
  } = usePouzitiePredpisList(predpisList);

  return {
    initialFilter: {
      searchTextHladanyTermin: mapSearchText(search.get('hladanyTermin')),
      searchTextDoktrinalnyZdroj: mapSearchText(search.get('doktrinalnyZdroj')),
      searchTextLegalnyZdroj: mapSearchText(search.get('legalnyZdroj')),
      pouzitiePredpisList,
      tezaurus,
    },
    initialFilterLoading: tezaurusStatus.loading || pouzitiePredpisListStatus.loading,
    initialFilterFinished: tezaurusStatus.finished || pouzitiePredpisListStatus.finished,
  };
};
